import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

/**
 * Display a collapsable content, with toggle button.
 *
 * Example :
 *
 *   <app-collapsable [(collapsed)]="myAccordionCollapse">
 *     <ng-container toggle>
 *       <span > {{ myAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
 *     </ng-container>
 *
 *     <ng-container collapsable>
 *       My content...
 *     </ng-container>
 *   </app-collapsable>
 */

@Component({
  selector: 'app-collapsable',
  templateUrl: './collapsable.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
})
export class CollapsableComponent {
  // *********************************************************************************************
  // * NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG *
  // * NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG *
  // *********************************************************************************************

  @Input() collapsed: boolean = true;

  @Output() collapsedChange = new EventEmitter<boolean>();

  public toggle(): void {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }
}
